import { LocalLoading } from '@caju-beneficios/react-web-commons'
import { UrlHelper } from '@caju-beneficios/sponsor-v2-lib/dist/lib/environment'
import { EnumProducts } from '@caju-beneficios/sponsor-v2-lib/dist/lib/environment/enumProducts'
import * as React from 'react'

export function HomePage() {

  /**
   * Como no primeiro momento nao termos nada em shared
   * a ideia é que nesse primeiro momento seja redirecionado 
   * para o produto classic
   */
  React.useEffect(() => {
    const url = UrlHelper.getUrl(EnumProducts.CLASSIC, '/') 
    window.location.assign(url)
  }, [])

  // ---------------------------------------------
  // Transformations
  // ---------------------------------------------
  // Render

  return (
    <div className={'home-page'}>
      <LocalLoading show message='Um momento' />
    </div>
  )
}
